"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    .ecr-success-header-wrapper {
        text-align: center;
        .ecrs-content {
            position: relative;
        }
        .right-part {
            h1 {
                font-size: 2.5vw;
            }
            h3 {
                font-size: 1.5vw;
            }
            h4 {
                margin-top: 0;
            }
            @media screen and ${constants_1.Device.tablet} {
                h1 {
                    font-size: 5vw;
                }
                h3 {
                    font-size: 3vw;
                }
                div.centered {
                    text-align: center;
                }
            }
        }
        ul {
            flex-direction: column;
        }
        ul,
        li {
            display: flex;
            list-style: none;
            padding-left: 0;
        }
        li:first-child h4 {
            margin-top: -4px;
        }
        li {
            display: flex;
            align-items: self-start;
            justify-content: stretch;
            flex-direction: row;
            width: 100%;
            min-height: 3vw;
            margin-bottom: 1vw;
            .circle {
                display: flex;
                border-radius: 50%;
                border: 1.5px solid white;
                height: 2vw;
                width: 2vw;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                color: white;
                min-width: 2vw;
                min-height: 2vw;
                margin-right: 1vw;
                @media screen and ${constants_1.Device.desktop} {
                    min-width: 40px;
                    min-height: 40px;
                }
            }
        }
        li.center {
            align-items: center;
            margin-bottom: 1vw;
        }
        .ecrs-button {
            font-size: 1em;
            outline: none;
            border: none;
            width: 250px;
            display: inline-block;
            padding: 0.4vw;
            color: black;
            background: $yellow;
            text-align: center;
            @media screen and ${constants_1.Device.mobileL} {
                max-width: 200px;
            }
            @media screen and ${constants_1.Device.tablet} {
                padding: 1.5vw 1vw 1vw 1vw;
            }
        }
        .ecrs-copiedText {
            opacity: 0;
            transition: opacity 0.3s;
            background: white;
            padding: 0.5em 1em;
            font-size: 0.8em;
            margin-top: 0.2vw;
            &.copied {
                opacity: 1;
                margin-left: 1em;
            }
        }
    }
    body[data-ios='true'],
    body[data-iphone='true'] {
        .ecr-success-header-wrapper {
            .right-part {
                @media screen and ${constants_1.Device.tablet} {
                    h1 {
                        font-size: 4.5vw;
                    }
                }
            }
        }
    }
    .ecrp-bonus-wrapper {
        width: 270px;
        font-size: 15px;
        text-align: center;
    }
    .ecrp-bonus-content {
        padding-top: 10px;
        margin-bottom: 1em;
    }
`;
//# sourceMappingURL=SuccessHeaderStyled.js.map